import { render, staticRenderFns } from "./PAApplicant.vue?vue&type=template&id=05e63230&"
import script from "./PAApplicant.vue?vue&type=script&lang=js&"
export * from "./PAApplicant.vue?vue&type=script&lang=js&"
import style0 from "./PAApplicant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAApplicant.vue"
export default component.exports